import keycloakClient from "@keycloak/keycloak";
import { BACKEND_API_URL } from "../../config";
import type {
  ThreadMessagesResponse,
  ThreadsResponse
} from "./models";

class ThreadsService {
  private baseUrl: string;

  constructor(baseUrl: string) {
    this.baseUrl = baseUrl;
  }

  private getAuthHeaders(): HeadersInit {
    return {
      Authorization: `Bearer ${keycloakClient.token}`,
      Accept: "application/json"
    };
  }

  async getThreads(page: number, limit: number): Promise<ThreadsResponse> {
    const params = new URLSearchParams({
      page: String(page),
      limit: String(limit)
    });

    const response = await fetch(
      `${this.baseUrl}/threads/threads?${params.toString()}`,
      {
        method: "GET",
        headers: this.getAuthHeaders()
      }
    );

    if (!response.ok) {
      throw new Error(
        `Error fetching threads: ${response.status} ${response.statusText}`
      );
    }

    return (await response.json()) as ThreadsResponse;
  }

  async getThreadMessages(
    threadId: string,
    page: number,
    limit: number
  ): Promise<ThreadMessagesResponse> {
    const params = new URLSearchParams({
      page: String(page),
      limit: String(limit)
    });

    const response = await fetch(
      `${this.baseUrl}/threads/thread/${threadId}?${params.toString()}`,
      {
        method: "GET",
        headers: this.getAuthHeaders()
      }
    );

    if (!response.ok) {
      throw new Error(
        `Error fetching thread messages: ${response.status} ${response.statusText}`
      );
    }

    return (await response.json()) as ThreadMessagesResponse;
  }
}

export const threadsService = new ThreadsService(
  `${BACKEND_API_URL}/chatbot-api/v1`
);

